<script>

    import { _ } from 'svelte-i18n';

    const { value = null, availableTimes = [], onTimeChange, onConfirm } = $props();

    let fieldsetEl;

    export function focus() {
        const first = fieldsetEl?.querySelector('input[type="radio"]');
        if (first) {
            first.checked = true;
            first.dispatchEvent(new Event('change', { bubbles: true }));
            first.focus();
        }
    }

    function formatTime(timeString) {
        const [hours, minutes] = timeString.split(':');
        return `${parseInt(hours, 10)}:${minutes}`;
    }

    function handleTimeChange(event) {
        if (onTimeChange) {
            onTimeChange(event.target.value);
        }
    }

    function needsDivider(time, index, times) {
        if (index >= times.length - 1) return false;
        
        const currentHour = parseInt(time.split(':')[0]);
        const nextTime = times[index + 1];
        const nextHour = parseInt(nextTime.split(':')[0]);
        
        // Add divider when crossing from 11:xx to 12:xx or from 17:xx to 18:xx
        return (currentHour < 12 && nextHour >= 12) || (currentHour < 18 && nextHour >= 18);
    }

</script>

<div id="time-picker">
    <fieldset bind:this={fieldsetEl}>
        <legend class="sr-only">{$_('time')}</legend>
        {#each availableTimes as time, index}
            <label>
                <input type="radio" name="time" value={time} onchange={handleTimeChange} checked={value === time} onkeydown={(e) => { if (e.key === 'Enter') { e.preventDefault(); if (onConfirm) onConfirm(); } }} />
                {formatTime(time)}
            </label>

            {#if needsDivider(time, index, availableTimes)}
                <hr />
            {/if}
        {/each}
    </fieldset>
</div>

<style>

    #time-picker {
        margin: 0;
        flex: 1;
        min-width: 18em;
    }

    #time-picker fieldset {
        margin: 0;
        padding: 0;
        border: none;
        display: grid;
        gap: 1em;
        grid-template-columns: repeat(auto-fill, minmax(5em, 1fr));
        margin-bottom: 2em;
    }

    #time-picker fieldset label {
        list-style-type: none;
        background: var(--box-color);
        padding: 0.7em 1em;
        border-radius: 8px;
        text-align: center;

        cursor: pointer;
    }

    #time-picker fieldset label:has(input:checked) {
        background: var(--text-color);
        color: var(--background-color);

        box-shadow: 0 0 0 3px var(--background-color), 0 0 0 5px var(--accent-contrast);
    }

    #time-picker fieldset label input {
        position: absolute;
        clip: rect(0,0,0,0);
    }

    hr {
        border: none;
        grid-column: 1 / -1; /* Span full width of grid */
        height: 0em;
        margin-top: -0.5em;
    }

</style>